import { StrictMode, Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { App } from './App.tsx';
import { LoginPage } from './pages/LoginPage.tsx';
import { RepoListPage } from './pages/RepoListPage.tsx';
import { RepoViewPage } from './pages/RepoViewPage.tsx';
import './styles.css';

// Pages hors du chemin critique (GU-358) : chargées à la première visite plutôt que dans le bundle
// initial. Connexion, liste des dépôts et vue d'un dépôt (page d'atterrissage la plus fréquente, avec
// le graphe) restent en import statique. Les pages exportent des composants nommés : React.lazy
// attend un export par défaut, d'où le `.then` qui le fabrique.
const AuditLogPage = lazy(() => import('./pages/AuditLogPage.tsx').then((m) => ({ default: m.AuditLogPage })));
const MonitoringPage = lazy(() => import('./pages/MonitoringPage.tsx').then((m) => ({ default: m.MonitoringPage })));
const pageFallback = <p className="muted" style={{ padding: 16 }}>Chargement…</p>;

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />}>
          <Route index element={<Navigate to="/repos" replace />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="repos" element={<RepoListPage />} />
          <Route path="repos/:id" element={<RepoViewPage />} />
          <Route path="audit-log" element={<Suspense fallback={pageFallback}><AuditLogPage /></Suspense>} />
          <Route path="monitoring" element={<Suspense fallback={pageFallback}><MonitoringPage /></Suspense>} />
        </Route>
      </Routes>
    </BrowserRouter>
  </QueryClientProvider>
  </StrictMode>,
);
